// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__nwcDV","pageTab":"NavBar_pageTab__3MGEU","pageTab_active":"NavBar_pageTab_active__MTC0f","pageTab_inactive":"NavBar_pageTab_inactive__7buhT"};